export class RegExpEscaper {

    // These are metacharacters used in Regular Expression: http://speakingjs.com/es5/ch19.html
    // These will be interpreted in special way if specified inside Regular Expression.
    // In order to search for text containing metacharacters we need to escape them.
    // The implementation is identical to the one proposed for adoption to standard:
    // https://github.com/benjamingr/RegExp.escape
    private static get MetacharactersMatch(): RegExp { return /[\\^$*+?.()|[\]{}]/g; }
    private static get MetacharactersReplacement(): string { return '\\$&'; }

    /**
     * Escapes metacharacters so given string can be matched against in regular expressions
     */
    public static escape(unescapedString: string): string {
        return unescapedString.replace(RegExpEscaper.MetacharactersMatch, RegExpEscaper.MetacharactersReplacement);
    }
}
